
import homeQuery from "@/apollo/queries/pages/home.gql";
import lenisScrollMixin from '@/mixins/lenisScrollMixin';
import previewModeMixin from '@/mixins/previewModeMixin';

export default {
  name: 'index',
  colorMode: 'light',
  mixins: [lenisScrollMixin, previewModeMixin],
  data() {
    return {
      home: null,
      sliderHeight: null,
      resizeObserver: null,
    };
  },
  computed: {
    sliderSectionStyle() {
      return this.sliderHeight ? {
        height: this.sliderHeight,
        minHeight: this.sliderHeight,
        maxHeight: this.sliderHeight,
        '--slider-height': this.sliderHeight,
      } : null;
    },
  },
  async asyncData({app, store}) {
    const previewMode = store.state.previewMode;

    if (previewMode) {
      await app.apolloProvider.defaultClient.resetStore();
    }

    const responseHome = await app.apolloProvider.defaultClient.query({
      query: homeQuery,
      variables: {
        locale: app.i18n.locale || 'en',
      },
    }).catch((err) => {
      console.log(JSON.stringify(err, null, 2));
    });

    const home = responseHome.data?.studioFrank;

    return {
      home,
      previewMode,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.updateSliderHeight();
      window.addEventListener('resize', this.updateSliderHeight);
      this.initializeResizeObserver();
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateSliderHeight);
    this.resizeObserver?.disconnect();
  },
  methods: {
    initializeResizeObserver() {
      if (typeof ResizeObserver === 'undefined') {
        return;
      }

      const header = document.querySelector('header');
      const footer = this.$refs.pageFooter?.$el;

      this.resizeObserver = new ResizeObserver(() => {
        this.updateSliderHeight();
      });

      if (header) {
        this.resizeObserver.observe(header);
      }

      if (footer) {
        this.resizeObserver.observe(footer);
      }
    },
    updateSliderHeight() {
      if (process.server) {
        return;
      }

      const header = document.querySelector('header');
      const footer = this.$refs.pageFooter?.$el;
      const viewportHeight = window.innerHeight;
      const headerHeight = header?.offsetHeight || 0;
      const footerHeight = footer?.offsetHeight || 0;
      const availableHeight = Math.max(viewportHeight - headerHeight - footerHeight, 0);

      this.sliderHeight = `${availableHeight}px`;
    },
  },
}
